import { render, staticRenderFns } from "./Logout-button.vue?vue&type=template&id=333f0430&scoped=true"
import script from "./Logout-button.vue?vue&type=script&lang=js"
export * from "./Logout-button.vue?vue&type=script&lang=js"
import style0 from "./Logout-button.vue?vue&type=style&index=0&id=333f0430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333f0430",
  null
  
)

export default component.exports